import CustomCard from "../../../components/card";
import net from "../../../data/network.json";
import coins from "../../../data/coinList.json";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  IconButton,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import {
  wrapperHeader,
  wrapperItem,
  wrapperMain,
  wrapperMiddle,
  wrapperTopPart,
} from "./swapDetails.style";
import useAppSelector from "../../../hooks/useSelector";
import EastIcon from "@mui/icons-material/East";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { FC, useEffect, useState } from "react";
import { IRes } from "../../../services/createExchange";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useMutation } from "@tanstack/react-query";
import { exchangeInfoService } from "../../../services/exchangeInfo";
import { wrapperCex } from "../swapConfirmation/SwapConfirmation.style";
import CloseIcon from "@mui/icons-material/Close";
import {
  setFromWalletAddressData,
  setToWalletAddressData,
  setValidAddressFromData,
  setValidAddressToData,
} from "../../../redux/slices/walletAddress";
import useAppDispatch from "../../../hooks/useDispatch";
import partner from "../../../data/partner.json";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { store } from "../../../redux/store";
import { setToast } from "../../../redux/slices/toastSlice";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { setFromValueData } from "../../../redux/slices/coinFromValueSlice";
import { setSelectedExchangeData } from "../../../redux/slices/selectedExchangeSlice";
import {
  setExchangeResData,
  setRateId,
} from "../../../redux/slices/exchangeResSlice";
import {
  setFromCoinSelectData,
  setToCoinSelectData,
} from "../../../redux/slices/coinSelectSlice";
import {
  setNetIconFromData,
  setNetIconToData,
} from "../../../redux/slices/netIconSlice";
import {
  setExtraIdFromData,
  setExtraIdToData,
} from "../../../redux/slices/extraIdSlice";
import {
  setNetMemoFromData,
  setNetMemoToData,
} from "../../../redux/slices/netMemoSlice";
import { baseImageUrl } from "../../../config/imageUrl";
import { AxiosError } from "axios";

interface IProps {
  setSwapDetail: (arg0: boolean) => void;
  setConfirm: (arg0: boolean) => void;
  setShowWallet: (arg0: boolean) => void;
  detailData?: IRes | undefined;
  exchangeInfo: any;
  historyRequestId: string;
  setSwitch: (arg0: number) => void;
  setLoading: (arg0: boolean) => void;
  setActive: (arg0: number) => void;
}
const SwapDetails: FC<IProps> = ({
  setSwapDetail,
  setConfirm,
  setShowWallet,
  detailData,
  exchangeInfo,
  historyRequestId,
  setSwitch,
  setLoading,
  setActive,
}) => {
  const dispatch = useAppDispatch();
  const [nextStep, setNextStep] = useState<string[]>([]);
  const [expanded, setExpanded] = useState<any>({
    waiting: false,
    overdue: false,
    confirming: false,
    exchanging: false,
    sending: false,
    finished: false,
    failed: false,
  });

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    switch (exchangeInfo?.status) {
      case "waiting":
        setExpanded("waiting");
        setNextStep(["waiting"]);
        break;
      case "confirming":
        setExpanded("confirming");
        setNextStep(["waiting", "confirming"]);
        break;
      case "exchanging":
        setExpanded("exchanging");
        setNextStep(["waiting", "confirming", "exchanging"]);
        break;
      case "sending":
        setExpanded("sending");
        setNextStep(["sending", "waiting", "confirming", "exchanging"]);
        break;
      case "finished":
        setExpanded("finished");
        setNextStep([
          "finished",
          "sending",
          "waiting",
          "confirming",
          "exchanging",
        ]);
        break;
      case "overdue":
        setExpanded("overdue");
        setNextStep(["waiting", "overdue"]);
        break;
      case "failed":
        setExpanded("failed");
        setNextStep(["waiting", "failed"]);
        break;
      case "refunded":
        setExpanded("refunded");
        setNextStep(["waiting", "confirming", "refunded"]);
        break;
      default:
        setExpanded("");
        setNextStep([]);
    }
  }, [exchangeInfo?.status]);

  const selectedExchangeData = useAppSelector(
    (state) => state.selectedExchange
  );

  const exchangeInfoQuery = useMutation({
    mutationFn: exchangeInfoService,
  });
  const exchangeResData = useAppSelector((state) => state.exchangeRes);

  const handleRedo = () => {
    let id = historyRequestId ? historyRequestId : detailData?.exchangeID;
    exchangeInfoQuery.mutate(id, {
      onSuccess(data) {
        const searchParams = new URLSearchParams(location.search);
        searchParams.set("symbol_from", data?.data?.symbol_from);
        searchParams.set(
          "network_from",
          net.filter(
            (item) =>
              item?.name.toUpperCase() ===
              data?.data?.network_from.toUpperCase()
          )?.[0]?.name
        );
        searchParams.set("symbol_to", data?.data?.symbol_to);
        searchParams.set(
          "network_to",
          net.filter(
            (item) =>
              item?.name.toUpperCase() === data?.data?.network_to.toUpperCase()
          )?.[0]?.name
        );
        searchParams.set("amount", data?.data?.amount_from);
        navigate(
          {
            pathname: location.pathname,
            search: searchParams.toString(),
          },
          { replace: true }
        );
        setLoading(true);
        setSwapDetail(false);
        setConfirm(false);
        setShowWallet(false);
        setSwitch(1);
        dispatch(setFromValueData(data?.data?.amount_from));
        dispatch(
          setToCoinSelectData({
            id: data?.data?.currency_to,
            symbol: data?.data?.symbol_to,
            fullname: coins.filter(
              (item) => item.id === data?.data?.currency_to
            )?.[0]?.fullname,
            network: data?.data?.network_to,
            uuid: coins.filter(
              (item) => item.id === data?.data?.currency_to
            )?.[0]?.uuid,
            image: `${baseImageUrl}/${
              coins.filter((item) => item.id === data?.data?.currency_to)?.[0]
                ?.image
            }`,
            marketCap: coins.filter(
              (item) => item.id === data?.data?.currency_to
            )?.[0]?.marketCap,
            contractAddresses: [],
          })
        );
        dispatch(
          setFromCoinSelectData({
            id: data?.data?.currency_from,
            symbol: data?.data?.symbol_from,
            fullname: coins.filter(
              (item) => item.id === data?.data?.currency_from
            )?.[0]?.fullname,
            network: data?.data?.network_from,
            uuid: coins.filter(
              (item) => item.id === data?.data?.currency_from
            )?.[0]?.uuid,
            image: `${baseImageUrl}/${
              coins.filter((item) => item.id === data?.data?.currency_from)?.[0]
                ?.image
            }`,
            marketCap: coins.filter(
              (item) => item.id === data?.data?.currency_from
            )?.[0]?.marketCap,
            contractAddresses: [],
          })
        );
        dispatch(
          setNetIconFromData(
            `${baseImageUrl}/${
              net.filter(
                (item) =>
                  item?.name.toUpperCase() ===
                  data?.data?.network_from.toUpperCase()
              )?.[0]?.image
            }`
          )
        );
        dispatch(
          setNetIconToData(
            `${baseImageUrl}/${
              net.filter(
                (item) =>
                  item.name.toUpperCase() ===
                  data?.data?.network_to.toUpperCase()
              )?.[0]?.image
            }`
          )
        );
        dispatch(setExchangeResData());
        dispatch(setRateId());
        dispatch(setSelectedExchangeData());
      },
      onError(error) {
        const axiosError = error as AxiosError;
        if (axiosError.response?.status === 403) {
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
        store.dispatch(
          setToast({
            open: true,
            type: "error",
            text: error?.message,
          })
        );
      },
    });
  };

  const handleFinish = () => {
    setActive(0);
    setSwapDetail(false);
    setConfirm(false);
    setShowWallet(false);
    setLoading(true);
    setSwitch(1);
    dispatch(setExchangeResData());
    dispatch(setRateId());
    dispatch(setFromWalletAddressData());
    dispatch(setToWalletAddressData());
    dispatch(setValidAddressToData(false));
    dispatch(setValidAddressFromData(false));
    dispatch(setExtraIdFromData(""));
    dispatch(setExtraIdToData(""));
    dispatch(setNetMemoFromData(false));
    dispatch(setNetMemoToData(false));

    const ulrQuery = {
      symbol_from: "btc",
      network_from: "btc",
      symbol_to: "eth",
      network_to: "eth",
      amount: "0.1",
    };

    const defaultParams = new URLSearchParams(ulrQuery);

    navigate(`${location.pathname}?${defaultParams.toString()}`, {
      replace: true,
    });
    if (
      ulrQuery.symbol_from &&
      ulrQuery.symbol_to &&
      ulrQuery.network_from &&
      ulrQuery.network_to
    ) {
      dispatch(
        setFromCoinSelectData(
          coins.filter(
            (item) =>
              item?.symbol.toUpperCase() === ulrQuery.symbol_from.toUpperCase()
          )?.[0]
        )
      );
      dispatch(
        setToCoinSelectData(
          coins.filter(
            (item) =>
              item?.symbol.toUpperCase() === ulrQuery.symbol_to.toUpperCase()
          )?.[0]
        )
      );
      dispatch(
        setNetIconFromData(
          `${baseImageUrl}/${
            net.filter((item) => item?.name === ulrQuery.network_from)?.[0]
              ?.image
          }`
        )
      );
      dispatch(
        setNetIconToData(
          `${baseImageUrl}/${
            net.filter((item) => item?.name === ulrQuery.network_to)?.[0]?.image
          }`
        )
      );
    }
  };

  const handleCopy = () => {
    store.dispatch(
      setToast({
        open: true,
        type: "success",
        text: "Copied to the clipboard",
      })
    );
  };
  return (
    <Grid
      sx={wrapperMain}
      className="animate__animated animate__fadeIn fix_layout"
    >
      <CustomCard>
        <Grid sx={wrapperHeader} mt={2} mb={3}>
          <IconButton onClick={handleFinish}>
            <CloseIcon />
          </IconButton>
          <Typography variant="h5">Swap Detail</Typography>
        </Grid>
        <Grid
          sx={{
            ...wrapperTopPart,
            background: (theme) => theme?.palette?.secondary?.light,
            borderRadius: "8px",
          }}
          p={2}
          container
        >
          <Grid sx={wrapperItem}>
            <Typography pl={6}>From</Typography>
            <Grid container style={{ position: "relative" }}>
              <img
                src={
                  coins.find(
                    (coin) =>
                      coin?.id?.toUpperCase() ===
                      exchangeInfo?.currency_from?.toUpperCase()
                  )?.image
                    ? `${baseImageUrl}/${
                        coins.find(
                          (coin) =>
                            coin?.id?.toUpperCase() ===
                            exchangeInfo?.currency_from?.toUpperCase()
                        )?.image
                      }`
                    : "/assets/images/coins/noPic.svg"
                }
                alt="flashift"
                width="40px"
                height="40px"
              />

              <img
                src={
                  net.find(
                    (item) =>
                      item?.name?.toUpperCase() ===
                      exchangeInfo?.network_from?.toUpperCase()
                  )?.image
                    ? `${baseImageUrl}/${
                        net.find(
                          (item) =>
                            item?.name?.toUpperCase() ===
                            exchangeInfo?.network_from?.toUpperCase()
                        )?.image
                      }`
                    : "/assets/images/coins/noPic.svg"
                }
                alt="flashift"
                width="15.5px"
                height="15.5px"
                className="netIcon"
                style={{ left: "30px" }}
              />

              <Typography variant="h6" pl={1} mt={0.5}>
                {exchangeInfo?.symbol_from.toUpperCase()}
                <Typography>
                  {net
                    .filter(
                      (item) =>
                        item?.name.toUpperCase() ===
                        exchangeInfo?.network_from.toUpperCase()
                    )?.[0]
                    ?.name.toUpperCase()}
                </Typography>
              </Typography>
            </Grid>
            <Grid
              container
              style={{ justifyContent: "space-between" }}
              pl={0.7}
            >
              <Typography variant="h5">{exchangeInfo?.amount_from}</Typography>
            </Grid>
          </Grid>
          <Grid sx={wrapperItem}>
            <Typography pl={9.5}>To</Typography>
            <Grid container style={{ position: "relative" }}>
              <Grid mr={1} mt={2}>
                <EastIcon />
              </Grid>
              <img
                alt="flashift"
                src={
                  coins.find(
                    (coin) =>
                      coin?.id?.toUpperCase() ===
                      exchangeInfo?.currency_to?.toUpperCase()
                  )?.image
                    ? `${baseImageUrl}/${
                        coins.find(
                          (coin) =>
                            coin?.id?.toUpperCase() ===
                            exchangeInfo?.currency_to?.toUpperCase()
                        )?.image
                      }`
                    : "/assets/images/coins/noPic.svg"
                }
                width="40px"
                height="40px"
              />

              <img
                alt="flashift"
                src={
                  net.find(
                    (item) =>
                      item?.name?.toUpperCase() ===
                      exchangeInfo?.network_to?.toUpperCase()
                  )?.image
                    ? `${baseImageUrl}/${
                        net.find(
                          (item) =>
                            item?.name?.toUpperCase() ===
                            exchangeInfo?.network_to?.toUpperCase()
                        )?.image
                      }`
                    : "/assets/images/coins/noPic.svg"
                }
                width="15.5px"
                height="15.5px"
                className="netIcon"
                style={{ left: "50px" }}
              />

              <Typography variant="h6" pl={1} mt={0.5}>
                {exchangeInfo?.symbol_to.toUpperCase()}
                <Typography>
                  {net
                    .filter(
                      (item) =>
                        item?.name.toUpperCase() ===
                        exchangeInfo?.network_to.toUpperCase()
                    )?.[0]
                    ?.name.toUpperCase()}
                </Typography>
              </Typography>
            </Grid>

            <Grid
              container
              style={{ justifyContent: "space-between" }}
              pl={4.7}
            >
              <Typography variant="h5">
                {exchangeInfo?.amount_to.toFixed(5)}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          sx={{
            ...wrapperCex,
            background: (theme) => theme?.palette?.secondary?.light,
            borderRadius: "8px",
            marginTop: "20px",
          }}
          container
        >
          <Grid>
            <Typography>
              <span>
                {historyRequestId.split("_")[0] ? (
                  <img
                    src={`${baseImageUrl}/${
                      partner.filter(
                        (src) => src?.name === historyRequestId.split("_")[0]
                      )?.[0]?.image_small
                    }`}
                    alt="flashift"
                    height="24px"
                  />
                ) : selectedExchangeData?.selectedExchange?.partner_name ? (
                  <img
                    src={`${baseImageUrl}/${
                      partner.filter(
                        (src) =>
                          src?.name ===
                          selectedExchangeData?.selectedExchange?.partner_name
                      )?.[0]?.image_small
                    }`}
                    alt="flashift"
                    height="24px"
                  />
                ) : (
                  <img
                    src={`${baseImageUrl}/${
                      partner.filter(
                        (src) =>
                          src?.name ===
                          exchangeResData?.exchangeRes?.data[0]?.partner_name
                      )?.[0]?.image_small
                    }`}
                    alt="flashift"
                    height="24px"
                  />
                )}
              </span>
              <span> Swap Via</span>
              <span>
                {historyRequestId
                  ? historyRequestId.split("_")[0]
                  : selectedExchangeData?.selectedExchange?.partner_name
                  ? selectedExchangeData?.selectedExchange?.partner_name
                  : exchangeResData?.exchangeRes?.data[0]?.partner_name}
              </span>
            </Typography>
          </Grid>
          <Grid
            sx={{
              color: (theme) => theme?.palette?.primary?.main,
              fontWeight: "700",
            }}
            pl={1}
          >
            Cex -
            <img
              alt="flashift"
              style={{
                width: "17px",
                position: "relative",
                top: "3px",
              }}
              src={
                (historyRequestId
                  ? historyRequestId.split("_")[1]
                  : selectedExchangeData?.selectedExchange?.exchange_type
                  ? selectedExchangeData?.selectedExchange?.exchange_type
                  : exchangeResData?.exchangeRes?.data[0]?.exchange_type) ===
                "floating"
                  ? "/assets/images/routes/float.svg"
                  : "/assets/images/routes/fixed.png"
              }
            />
            {historyRequestId
              ? historyRequestId.split("_")[1]
              : selectedExchangeData?.selectedExchange?.exchange_type
              ? selectedExchangeData?.selectedExchange?.exchange_type
              : exchangeResData?.exchangeRes?.data[0]?.exchange_type}
          </Grid>
        </Grid>
        <Grid sx={wrapperMiddle} container mb={3} px={1}>
          <Typography variant="h6">Request ID :</Typography>
          <Typography className="long_text">
            {historyRequestId ? historyRequestId : detailData?.exchangeID}
            <CopyToClipboard
              text={historyRequestId || detailData?.exchangeID || ""}
              onCopy={handleCopy}
            >
              <img
                src="./assets/images/swapDetails/copy.svg"
                alt="flashift"
                style={{
                  marginLeft: "5px",
                  position: "relative",
                  top: "4px",
                  cursor: "pointer",
                }}
              />
            </CopyToClipboard>
          </Typography>
        </Grid>
        <Grid>
          {/* waiting */}
          <Accordion expanded={expanded === "waiting"}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
            >
              <Typography variant="h6" mt={1}>
                {expanded === "waiting" ? (
                  <IconButton className="ok" style={{ marginRight: "5px" }}>
                    <img
                      src="./assets/images/swapDetails/loading.svg"
                      alt="flashift"
                      className="loading"
                    />
                  </IconButton>
                ) : nextStep.includes("overdue") ||
                  nextStep.includes("failed") ? (
                  <IconButton className="ok" style={{ marginRight: "5px" }}>
                    <HighlightOffIcon style={{ color: "#e74c3c" }} />
                  </IconButton>
                ) : (
                  <IconButton className="ok" style={{ marginRight: "5px" }}>
                    <CheckCircleOutlineIcon />
                  </IconButton>
                )}
                Waiting for Payment
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              {net.filter(
                (item) =>
                  item.name.toUpperCase() ===
                  exchangeInfo?.network_from.toUpperCase()
              )?.[0]?.networkid !== null && (
                <Grid className="trust_wallet">
                  <Button
                    variant="contained"
                    fullWidth
                    style={{ marginBottom: "8px", paddingTop: "3px" }}
                  >
                    <Link
                      to={`https://link.trustwallet.com/send?asset=c${
                        net.filter(
                          (item) =>
                            item.name.toUpperCase() ===
                            exchangeInfo?.network_from.toUpperCase()
                        )?.[0]?.networkid
                      }_t${(() => {
                        const contract = coins.find(
                          (item) =>
                            item.id.toUpperCase() ===
                            exchangeInfo?.currency_from.toUpperCase()
                        )?.contract;
                        return contract ? `${contract}` : "";
                      })()}&address=${exchangeInfo?.address_from}&amount=${
                        exchangeInfo?.amount_from
                      }&memo=${exchangeInfo?.extera_from}`}
                      target={"_blank"}
                    >
                      <img
                        src="./assets/images/swapDetails/wallet.svg"
                        style={{ position: "relative", top: "7px" }}
                      />
                      Pay with Trustwallet
                    </Link>
                  </Button>
                </Grid>
              )}
              <Grid className="specific_card" p={1} mb={1.2}>
                <Typography variant="h5" style={{ display: "flex" }}>
                  <span style={{ marginRight: "8px" }}>Please send</span>
                  <Grid
                    sx={{
                      color: (theme) => theme?.palette?.primary?.main,
                    }}
                    mr={1}
                  >
                    {exchangeInfo?.amount_from}{" "}
                    {exchangeInfo?.symbol_from.toUpperCase()} {""}
                    {exchangeInfo?.network_from && (
                      <span
                        className="net_wrapper"
                        style={{ position: "relative", top: "-3px" }}
                      >
                        {exchangeInfo?.network_from.toUpperCase()}
                      </span>
                    )}
                  </Grid>
                  to:
                </Typography>
                <Typography className="text_item long_text">
                  {exchangeInfo?.address_from}
                  <CopyToClipboard
                    text={exchangeInfo?.address_from}
                    onCopy={handleCopy}
                  >
                    <img
                      src="./assets/images/swapDetails/copy.svg"
                      alt="flashift"
                      style={{
                        marginLeft: "5px",
                        position: "relative",
                        top: "4px",
                        cursor: "pointer",
                      }}
                    />
                  </CopyToClipboard>
                </Typography>
              </Grid>
              {exchangeInfo?.extera_from && (
                <Grid className="extra_item">
                  <Typography variant="h5" style={{ display: "flex" }}>
                    Extra ID :
                  </Typography>
                  <Typography className="text_item long_text">
                    {exchangeInfo?.extera_from}
                    <span style={{ color: "#FF9800" }}>(Required!)</span>
                    <CopyToClipboard
                      text={exchangeInfo?.extera_from}
                      onCopy={handleCopy}
                    >
                      <img
                        src="./assets/images/swapDetails/copy.svg"
                        alt="flashift"
                        style={{
                          marginLeft: "5px",
                          position: "relative",
                          top: "4px",
                          cursor: "pointer",
                        }}
                      />
                    </CopyToClipboard>
                  </Typography>
                </Grid>
              )}
              <Grid style={{ textAlign: "center" }}>
                <Typography variant="h6" mb={1}>
                  You can also scan this
                </Typography>
                <img
                  src={`https://api.qrserver.com/v1/create-qr-code/?size=100x100&data=${exchangeInfo?.address_from}`}
                  alt="flashift"
                />
              </Grid>
            </AccordionDetails>
          </Accordion>
          {/* overdue */}
          {nextStep.includes("overdue") && (
            <Accordion expanded={expanded === "overdue"}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2-content"
                id="panel2-header"
              >
                <IconButton className="ok" style={{ marginRight: "5px" }}>
                  <HighlightOffIcon style={{ color: "#e74c3c" }} />
                </IconButton>
                Overdue
              </AccordionSummary>
            </Accordion>
          )}
          {/* failed */}
          {nextStep.includes("failed") && (
            <Accordion expanded={expanded === "failed"}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel3-content"
                id="panel3-header"
              >
                <IconButton className="ok" style={{ marginRight: "5px" }}>
                  <HighlightOffIcon style={{ color: "#e74c3c" }} />
                </IconButton>
                Failed
              </AccordionSummary>
              <AccordionDetails>
                <Grid className="specific_card" p={1} mb={1}>
                  <Typography variant="h5" style={{ display: "flex" }}>
                    <span style={{ marginRight: "8px" }}>You sent</span>
                    <Grid
                      sx={{
                        color: (theme) => theme?.palette?.primary?.main,
                      }}
                      mr={1}
                    >
                      {exchangeInfo?.amount_from}{" "}
                      {exchangeInfo?.symbol_from.toUpperCase()} {""}
                      {exchangeInfo?.network_from && (
                        <span
                          className="net_wrapper"
                          style={{ position: "relative", top: "-3px" }}
                        >
                          {exchangeInfo?.network_from.toUpperCase()}
                        </span>
                      )}
                    </Grid>
                    to:
                  </Typography>
                  <Typography className="text_item long_text">
                    {exchangeInfo?.address_from}
                    <CopyToClipboard
                      text={exchangeInfo?.address_from}
                      onCopy={handleCopy}
                    >
                      <img
                        src="./assets/images/swapDetails/copy.svg"
                        alt="flashift"
                        style={{
                          marginLeft: "5px",
                          position: "relative",
                          top: "4px",
                          cursor: "pointer",
                        }}
                      />
                    </CopyToClipboard>
                  </Typography>
                </Grid>
                {exchangeInfo?.extera_from && (
                  <Grid className="specific_card" p={1} mb={1}>
                    <Typography variant="h5">Extra ID:</Typography>
                    <Typography className="text_item long_text">
                      {exchangeInfo?.extera_from}
                      <CopyToClipboard
                        text={exchangeInfo?.extera_from}
                        onCopy={handleCopy}
                      >
                        <img
                          src="./assets/images/swapDetails/copy.svg"
                          alt="flashift"
                          style={{
                            marginLeft: "5px",
                            position: "relative",
                            top: "4px",
                            cursor: "pointer",
                          }}
                        />
                      </CopyToClipboard>
                    </Typography>
                  </Grid>
                )}
                {exchangeInfo?.hash_from && (
                  <Grid className="specific_card" p={1} mb={1}>
                    <Typography variant="h5">Hash:</Typography>
                    <Typography className="text_item long_text">
                      <Link
                        target="_blank"
                        to={`${
                          net.filter(
                            (item) =>
                              item?.name.toUpperCase() ===
                              exchangeInfo?.network_from.toUpperCase()
                          )?.[0]?.explorer
                        }${exchangeInfo?.hash_from}`}
                      >
                        {exchangeInfo?.hash_from}
                      </Link>
                      <CopyToClipboard
                        text={exchangeInfo?.hash_from}
                        onCopy={handleCopy}
                      >
                        <img
                          src="./assets/images/swapDetails/copy.svg"
                          alt="flashift"
                          style={{
                            marginLeft: "5px",
                            position: "relative",
                            top: "4px",
                            cursor: "pointer",
                          }}
                        />
                      </CopyToClipboard>
                    </Typography>
                  </Grid>
                )}

                <Grid className="specific_card" p={1} mb={1}>
                  <Typography variant="h5">
                    <span style={{ marginRight: "8px" }}>Recipient</span>
                    <Grid
                      sx={{
                        color: (theme) => theme?.palette?.primary?.main,
                      }}
                      mr={1}
                    >
                      {exchangeInfo?.amount_to}{" "}
                      {exchangeInfo?.symbol_to.toUpperCase()} {""}
                      {exchangeInfo?.network_to && (
                        <span
                          className="net_wrapper"
                          style={{ position: "relative", top: "-3px" }}
                        >
                          {exchangeInfo?.network_to.toUpperCase()}
                        </span>
                      )}
                    </Grid>
                    address:
                  </Typography>
                  <Typography className="text_item long_text">
                    {exchangeInfo?.address_to}
                    <CopyToClipboard
                      text={exchangeInfo?.address_to}
                      onCopy={handleCopy}
                    >
                      <img
                        src="./assets/images/swapDetails/copy.svg"
                        alt="flashift"
                        style={{
                          marginLeft: "5px",
                          position: "relative",
                          top: "4px",
                          cursor: "pointer",
                        }}
                      />
                    </CopyToClipboard>
                  </Typography>
                </Grid>
                {exchangeInfo?.extera_to && (
                  <Grid className="specific_card" p={1} mb={1}>
                    <Typography variant="h5">Extra ID:</Typography>
                    <Typography className="text_item long_text">
                      {exchangeInfo?.extera_to}
                      <CopyToClipboard
                        text={exchangeInfo?.extera_to}
                        onCopy={handleCopy}
                      >
                        <img
                          src="./assets/images/swapDetails/copy.svg"
                          alt="flashift"
                          style={{
                            marginLeft: "5px",
                            position: "relative",
                            top: "4px",
                            cursor: "pointer",
                          }}
                        />
                      </CopyToClipboard>
                    </Typography>
                  </Grid>
                )}
                {exchangeInfo?.hash_to && (
                  <Grid className="specific_card" p={1}>
                    <Typography variant="h5">Hash:</Typography>
                    <Typography className="text_item long_text">
                      <Link
                        target="_blank"
                        to={`${
                          net.filter(
                            (item) =>
                              item?.name.toUpperCase() ===
                              exchangeInfo?.network_to.toUpperCase()
                          )?.[0]?.explorer
                        }${exchangeInfo?.hash_to}`}
                      >
                        {exchangeInfo?.hash_to}
                      </Link>

                      <CopyToClipboard
                        text={exchangeInfo?.hash_to}
                        onCopy={handleCopy}
                      >
                        <img
                          src="./assets/images/swapDetails/copy.svg"
                          alt="flashift"
                          style={{
                            marginLeft: "5px",
                            position: "relative",
                            top: "4px",
                            cursor: "pointer",
                          }}
                        />
                      </CopyToClipboard>
                    </Typography>
                  </Grid>
                )}
              </AccordionDetails>
            </Accordion>
          )}
          {/* confirming* */}
          <Accordion
            expanded={expanded === "confirming"}
            disabled={!nextStep.includes("confirming")}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2-content"
              id="panel2-header"
            >
              {nextStep.includes("confirming") &&
              !nextStep.includes("exchanging") &&
              !nextStep.includes("refunded") ? (
                <img
                  src="./assets/images/swapDetails/loading.svg"
                  alt="flashift"
                  className="loading"
                />
              ) : nextStep.includes("confirming") &&
                (nextStep.includes("exchanging") ||
                  nextStep.includes("refunded")) ? (
                <IconButton className="ok" style={{ marginRight: "5px" }}>
                  <CheckCircleOutlineIcon />
                </IconButton>
              ) : (
                <IconButton className="ok" style={{ marginRight: "5px" }}>
                  <RemoveCircleOutlineIcon style={{ color: "#cacaca" }} />
                </IconButton>
              )}
              Confirming
            </AccordionSummary>
            <AccordionDetails>
              <Grid className="specific_card" p={1} mb={1}>
                <Typography variant="h5" style={{ display: "flex" }}>
                  <span style={{ marginRight: "8px" }}>You sent</span>
                  <Grid
                    sx={{
                      color: (theme) => theme?.palette?.primary?.main,
                    }}
                    mr={1}
                  >
                    {exchangeInfo?.amount_from}{" "}
                    {exchangeInfo?.symbol_from.toUpperCase()} {""}
                    {exchangeInfo?.network_from && (
                      <span
                        className="net_wrapper"
                        style={{ position: "relative", top: "-3px" }}
                      >
                        {exchangeInfo?.network_from.toUpperCase()}
                      </span>
                    )}
                  </Grid>
                  to:
                </Typography>
                <Typography className="text_item long_text">
                  {exchangeInfo?.address_from}
                  <CopyToClipboard
                    text={exchangeInfo?.address_from}
                    onCopy={handleCopy}
                  >
                    <img
                      src="./assets/images/swapDetails/copy.svg"
                      alt="flashift"
                      style={{
                        marginLeft: "5px",
                        position: "relative",
                        top: "4px",
                        cursor: "pointer",
                      }}
                    />
                  </CopyToClipboard>
                </Typography>
              </Grid>
              {exchangeInfo?.extera_from && (
                <Grid className="specific_card" p={1} mb={1}>
                  <Typography variant="h5">Extra ID:</Typography>
                  <Typography className="text_item long_text">
                    {exchangeInfo?.extera_from}
                    <CopyToClipboard
                      text={exchangeInfo?.extera_from}
                      onCopy={handleCopy}
                    >
                      <img
                        src="./assets/images/swapDetails/copy.svg"
                        alt="flashift"
                        style={{
                          marginLeft: "5px",
                          position: "relative",
                          top: "4px",
                          cursor: "pointer",
                        }}
                      />
                    </CopyToClipboard>
                  </Typography>
                </Grid>
              )}
              {exchangeInfo?.hash_from && (
                <Grid className="specific_card" p={1} mb={1}>
                  <Typography variant="h5">Hash:</Typography>
                  <Typography className="text_item long_text">
                    <Link
                      target="_blank"
                      to={`${
                        net.filter(
                          (item) =>
                            item?.name.toUpperCase() ===
                            exchangeInfo?.network_from.toUpperCase()
                        )?.[0]?.explorer
                      }${exchangeInfo?.hash_from}`}
                    >
                      {exchangeInfo?.hash_from}
                    </Link>
                    <CopyToClipboard
                      text={exchangeInfo?.hash_from}
                      onCopy={handleCopy}
                    >
                      <img
                        src="./assets/images/swapDetails/copy.svg"
                        alt="flashift"
                        style={{
                          marginLeft: "5px",
                          position: "relative",
                          top: "4px",
                          cursor: "pointer",
                        }}
                      />
                    </CopyToClipboard>
                  </Typography>
                </Grid>
              )}
              <Grid className="specific_card" p={1} mb={1}>
                <Typography variant="h5">
                  <span style={{ marginRight: "8px" }}>Recipient</span>
                  <Grid
                    sx={{
                      color: (theme) => theme?.palette?.primary?.main,
                    }}
                    mr={1}
                  >
                    {exchangeInfo?.amount_to}{" "}
                    {exchangeInfo?.symbol_to.toUpperCase()} {""}
                    {exchangeInfo?.network_to && (
                      <span
                        className="net_wrapper"
                        style={{ position: "relative", top: "-3px" }}
                      >
                        {exchangeInfo?.network_to.toUpperCase()}
                      </span>
                    )}
                  </Grid>
                  address:
                </Typography>
                <Typography className="text_item long_text">
                  {exchangeInfo?.address_to}
                  <CopyToClipboard
                    text={exchangeInfo?.address_to}
                    onCopy={handleCopy}
                  >
                    <img
                      src="./assets/images/swapDetails/copy.svg"
                      alt="flashift"
                      style={{
                        marginLeft: "5px",
                        position: "relative",
                        top: "4px",
                        cursor: "pointer",
                      }}
                    />
                  </CopyToClipboard>
                </Typography>
              </Grid>
              {exchangeInfo?.extera_to && (
                <Grid className="specific_card" p={1} mb={1}>
                  <Typography variant="h5">Extra ID:</Typography>
                  <Typography className="text_item long_text">
                    {exchangeInfo?.extera_to}
                    <CopyToClipboard
                      text={exchangeInfo?.extera_to}
                      onCopy={handleCopy}
                    >
                      <img
                        src="./assets/images/swapDetails/copy.svg"
                        alt="flashift"
                        style={{
                          marginLeft: "5px",
                          position: "relative",
                          top: "4px",
                          cursor: "pointer",
                        }}
                      />
                    </CopyToClipboard>
                  </Typography>
                </Grid>
              )}
              {exchangeInfo?.hash_to && (
                <Grid className="specific_card" p={1}>
                  <Typography variant="h5">Hash:</Typography>
                  <Typography className="text_item long_text">
                    <Link
                      target="_blank"
                      to={`${
                        net.filter(
                          (item) =>
                            item?.name.toUpperCase() ===
                            exchangeInfo?.network_to.toUpperCase()
                        )?.[0]?.explorer
                      }${exchangeInfo?.hash_to}`}
                    >
                      {exchangeInfo?.hash_to}
                    </Link>

                    <CopyToClipboard
                      text={exchangeInfo?.hash_to}
                      onCopy={handleCopy}
                    >
                      <img
                        src="./assets/images/swapDetails/copy.svg"
                        alt="flashift"
                        style={{
                          marginLeft: "5px",
                          position: "relative",
                          top: "4px",
                          cursor: "pointer",
                        }}
                      />
                    </CopyToClipboard>
                  </Typography>
                </Grid>
              )}
            </AccordionDetails>
          </Accordion>
          {/* refunded */}
          {nextStep.includes("refunded") && (
            <Accordion expanded={expanded === "refunded"}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel3-content"
                id="panel3-header"
              >
                <IconButton className="ok" style={{ marginRight: "5px" }}>
                  <CheckCircleOutlineIcon />
                </IconButton>
                Refunded
              </AccordionSummary>
              <AccordionDetails>
                <Grid className="specific_card" p={1} mb={1}>
                  <Typography variant="h5" style={{ display: "flex" }}>
                    <span style={{ marginRight: "8px" }}>You sent</span>
                    <Grid
                      sx={{
                        color: (theme) => theme?.palette?.primary?.main,
                      }}
                      mr={1}
                    >
                      {exchangeInfo?.amount_from}{" "}
                      {exchangeInfo?.symbol_from.toUpperCase()} {""}
                      {exchangeInfo?.network_from && (
                        <span
                          className="net_wrapper"
                          style={{ position: "relative", top: "-3px" }}
                        >
                          {exchangeInfo?.network_from.toUpperCase()}
                        </span>
                      )}
                    </Grid>
                    to:
                  </Typography>
                  <Typography className="text_item long_text">
                    {exchangeInfo?.address_from}
                    <CopyToClipboard
                      text={exchangeInfo?.address_from}
                      onCopy={handleCopy}
                    >
                      <img
                        src="./assets/images/swapDetails/copy.svg"
                        alt="flashift"
                        style={{
                          marginLeft: "5px",
                          position: "relative",
                          top: "4px",
                          cursor: "pointer",
                        }}
                      />
                    </CopyToClipboard>
                  </Typography>
                </Grid>
                {exchangeInfo?.extera_from && (
                  <Grid className="specific_card" p={1} mb={1}>
                    <Typography variant="h5">Extra ID:</Typography>
                    <Typography className="text_item long_text">
                      {exchangeInfo?.extera_from}
                      <CopyToClipboard
                        text={exchangeInfo?.extera_from}
                        onCopy={handleCopy}
                      >
                        <img
                          src="./assets/images/swapDetails/copy.svg"
                          alt="flashift"
                          style={{
                            marginLeft: "5px",
                            position: "relative",
                            top: "4px",
                            cursor: "pointer",
                          }}
                        />
                      </CopyToClipboard>
                    </Typography>
                  </Grid>
                )}
                {exchangeInfo?.hash_from && (
                  <Grid className="specific_card" p={1} mb={1}>
                    <Typography variant="h5">Hash:</Typography>
                    <Typography className="text_item long_text">
                      <Link
                        target="_blank"
                        to={`${
                          net.filter(
                            (item) =>
                              item?.name.toUpperCase() ===
                              exchangeInfo?.network_from.toUpperCase()
                          )?.[0]?.explorer
                        }${exchangeInfo?.hash_from}`}
                      >
                        {exchangeInfo?.hash_from}
                      </Link>
                      <CopyToClipboard
                        text={exchangeInfo?.hash_from}
                        onCopy={handleCopy}
                      >
                        <img
                          src="./assets/images/swapDetails/copy.svg"
                          alt="flashift"
                          style={{
                            marginLeft: "5px",
                            position: "relative",
                            top: "4px",
                            cursor: "pointer",
                          }}
                        />
                      </CopyToClipboard>
                    </Typography>
                  </Grid>
                )}

                <Grid className="specific_card" p={1} mb={1}>
                  <Typography variant="h5">
                    <span style={{ marginRight: "8px" }}>Recipient</span>
                    <Grid
                      sx={{
                        color: (theme) => theme?.palette?.primary?.main,
                      }}
                      mr={1}
                    >
                      {exchangeInfo?.amount_to}{" "}
                      {exchangeInfo?.symbol_to.toUpperCase()} {""}
                      {exchangeInfo?.network_to && (
                        <span
                          className="net_wrapper"
                          style={{ position: "relative", top: "-3px" }}
                        >
                          {exchangeInfo?.network_to.toUpperCase()}
                        </span>
                      )}
                    </Grid>
                    address:
                  </Typography>
                  <Typography className="text_item long_text">
                    {exchangeInfo?.address_to}
                    <CopyToClipboard
                      text={exchangeInfo?.address_to}
                      onCopy={handleCopy}
                    >
                      <img
                        src="./assets/images/swapDetails/copy.svg"
                        alt="flashift"
                        style={{
                          marginLeft: "5px",
                          position: "relative",
                          top: "4px",
                          cursor: "pointer",
                        }}
                      />
                    </CopyToClipboard>
                  </Typography>
                </Grid>
                {exchangeInfo?.extera_to && (
                  <Grid className="specific_card" p={1} mb={1}>
                    <Typography variant="h5">Extra ID:</Typography>
                    <Typography className="text_item long_text">
                      {exchangeInfo?.extera_to}
                      <CopyToClipboard
                        text={exchangeInfo?.extera_to}
                        onCopy={handleCopy}
                      >
                        <img
                          src="./assets/images/swapDetails/copy.svg"
                          alt="flashift"
                          style={{
                            marginLeft: "5px",
                            position: "relative",
                            top: "4px",
                            cursor: "pointer",
                          }}
                        />
                      </CopyToClipboard>
                    </Typography>
                  </Grid>
                )}
                {exchangeInfo?.hash_to && (
                  <Grid className="specific_card" p={1}>
                    <Typography variant="h5">Hash:</Typography>
                    <Typography className="text_item long_text">
                      <Link
                        target="_blank"
                        to={`${
                          net.filter(
                            (item) =>
                              item?.name.toUpperCase() ===
                              exchangeInfo?.network_to.toUpperCase()
                          )?.[0]?.explorer
                        }${exchangeInfo?.hash_to}`}
                      >
                        {exchangeInfo?.hash_to}
                      </Link>

                      <CopyToClipboard
                        text={exchangeInfo?.hash_to}
                        onCopy={handleCopy}
                      >
                        <img
                          src="./assets/images/swapDetails/copy.svg"
                          alt="flashift"
                          style={{
                            marginLeft: "5px",
                            position: "relative",
                            top: "4px",
                            cursor: "pointer",
                          }}
                        />
                      </CopyToClipboard>
                    </Typography>
                  </Grid>
                )}
              </AccordionDetails>
            </Accordion>
          )}
          {/* exchanging */}
          <Accordion
            expanded={expanded === "exchanging"}
            disabled={!nextStep.includes("exchanging")}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel3-content"
              id="panel3-header"
            >
              {nextStep.includes("exchanging") &&
              !nextStep.includes("sending") ? (
                <img
                  src="./assets/images/swapDetails/loading.svg"
                  alt="flashift"
                  className="loading"
                />
              ) : nextStep.includes("exchanging") &&
                nextStep.includes("sending") ? (
                <IconButton className="ok" style={{ marginRight: "5px" }}>
                  <CheckCircleOutlineIcon />
                </IconButton>
              ) : (
                <IconButton className="ok" style={{ marginRight: "5px" }}>
                  <RemoveCircleOutlineIcon style={{ color: "#cacaca" }} />
                </IconButton>
              )}
              Exchanging
            </AccordionSummary>
            <AccordionDetails>
              <Grid className="specific_card" p={1} mb={1}>
                <Typography variant="h5" style={{ display: "flex" }}>
                  <span style={{ marginRight: "8px" }}>You sent</span>
                  <Grid
                    sx={{
                      color: (theme) => theme?.palette?.primary?.main,
                    }}
                    mr={1}
                  >
                    {exchangeInfo?.amount_from}{" "}
                    {exchangeInfo?.symbol_from.toUpperCase()} {""}
                    {exchangeInfo?.network_from && (
                      <span
                        className="net_wrapper"
                        style={{ position: "relative", top: "-3px" }}
                      >
                        {exchangeInfo?.network_from.toUpperCase()}
                      </span>
                    )}
                  </Grid>
                  to:
                </Typography>
                <Typography className="text_item long_text">
                  {exchangeInfo?.address_from}
                  <CopyToClipboard
                    text={exchangeInfo?.address_from}
                    onCopy={handleCopy}
                  >
                    <img
                      src="./assets/images/swapDetails/copy.svg"
                      alt="flashift"
                      style={{
                        marginLeft: "5px",
                        position: "relative",
                        top: "4px",
                        cursor: "pointer",
                      }}
                    />
                  </CopyToClipboard>
                </Typography>
              </Grid>
              {exchangeInfo?.extera_from && (
                <Grid className="specific_card" p={1} mb={1}>
                  <Typography variant="h5">Extra ID:</Typography>
                  <Typography className="text_item long_text">
                    {exchangeInfo?.extera_from}
                    <CopyToClipboard
                      text={exchangeInfo?.extera_from}
                      onCopy={handleCopy}
                    >
                      <img
                        src="./assets/images/swapDetails/copy.svg"
                        alt="flashift"
                        style={{
                          marginLeft: "5px",
                          position: "relative",
                          top: "4px",
                          cursor: "pointer",
                        }}
                      />
                    </CopyToClipboard>
                  </Typography>
                </Grid>
              )}
              {exchangeInfo?.hash_from && (
                <Grid className="specific_card" p={1} mb={1}>
                  <Typography variant="h5">Hash:</Typography>
                  <Typography className="text_item long_text">
                    <Link
                      target="_blank"
                      to={`${
                        net.filter(
                          (item) =>
                            item?.name.toUpperCase() ===
                            exchangeInfo?.network_from.toUpperCase()
                        )?.[0]?.explorer
                      }${exchangeInfo?.hash_from}`}
                    >
                      {exchangeInfo?.hash_from}
                    </Link>
                    <CopyToClipboard
                      text={exchangeInfo?.hash_from}
                      onCopy={handleCopy}
                    >
                      <img
                        src="./assets/images/swapDetails/copy.svg"
                        alt="flashift"
                        style={{
                          marginLeft: "5px",
                          position: "relative",
                          top: "4px",
                          cursor: "pointer",
                        }}
                      />
                    </CopyToClipboard>
                  </Typography>
                </Grid>
              )}
              <Grid className="specific_card" p={1} mb={1}>
                <Typography variant="h5">
                  <span style={{ marginRight: "8px" }}>Recipient</span>
                  <Grid
                    sx={{
                      color: (theme) => theme?.palette?.primary?.main,
                    }}
                    mr={1}
                  >
                    {exchangeInfo?.amount_to}{" "}
                    {exchangeInfo?.symbol_to.toUpperCase()} {""}
                    {exchangeInfo?.network_to && (
                      <span
                        className="net_wrapper"
                        style={{ position: "relative", top: "-3px" }}
                      >
                        {exchangeInfo?.network_to.toUpperCase()}
                      </span>
                    )}
                  </Grid>
                  address:
                </Typography>
                <Typography className="text_item long_text">
                  {exchangeInfo?.address_to}
                  <CopyToClipboard
                    text={exchangeInfo?.address_to}
                    onCopy={handleCopy}
                  >
                    <img
                      src="./assets/images/swapDetails/copy.svg"
                      alt="flashift"
                      style={{
                        marginLeft: "5px",
                        position: "relative",
                        top: "4px",
                        cursor: "pointer",
                      }}
                    />
                  </CopyToClipboard>
                </Typography>
              </Grid>
              {exchangeInfo?.extera_to && (
                <Grid className="specific_card" p={1} mb={1}>
                  <Typography variant="h5">Extra ID:</Typography>
                  <Typography className="text_item long_text">
                    {exchangeInfo?.extera_to}
                    <CopyToClipboard
                      text={exchangeInfo?.extera_to}
                      onCopy={handleCopy}
                    >
                      <img
                        src="./assets/images/swapDetails/copy.svg"
                        alt="flashift"
                        style={{
                          marginLeft: "5px",
                          position: "relative",
                          top: "4px",
                          cursor: "pointer",
                        }}
                      />
                    </CopyToClipboard>
                  </Typography>
                </Grid>
              )}
              {exchangeInfo?.hash_to && (
                <Grid className="specific_card" p={1}>
                  <Typography variant="h5">Hash:</Typography>
                  <Typography className="text_item long_text">
                    <Link
                      target="_blank"
                      to={`${
                        net.filter(
                          (item) =>
                            item?.name.toUpperCase() ===
                            exchangeInfo?.network_to.toUpperCase()
                        )?.[0]?.explorer
                      }${exchangeInfo?.hash_to}`}
                    >
                      {exchangeInfo?.hash_to}
                    </Link>

                    <CopyToClipboard
                      text={exchangeInfo?.hash_to}
                      onCopy={handleCopy}
                    >
                      <img
                        src="./assets/images/swapDetails/copy.svg"
                        alt="flashift"
                        style={{
                          marginLeft: "5px",
                          position: "relative",
                          top: "4px",
                          cursor: "pointer",
                        }}
                      />
                    </CopyToClipboard>
                  </Typography>
                </Grid>
              )}
            </AccordionDetails>
          </Accordion>
          {/* sending */}
          <Accordion
            expanded={expanded === "sending"}
            disabled={!nextStep.includes("sending")}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel3-content"
              id="panel3-header"
            >
              {nextStep.includes("sending") &&
              !nextStep.includes("finished") ? (
                <img
                  src="./assets/images/swapDetails/loading.svg"
                  alt="flashift"
                  className="loading"
                />
              ) : nextStep.includes("sending") &&
                nextStep.includes("finished") ? (
                <IconButton className="ok" style={{ marginRight: "5px" }}>
                  <CheckCircleOutlineIcon />
                </IconButton>
              ) : (
                <IconButton className="ok" style={{ marginRight: "5px" }}>
                  <RemoveCircleOutlineIcon style={{ color: "#cacaca" }} />
                </IconButton>
              )}
              Sending
            </AccordionSummary>
            <AccordionDetails>
              <Grid className="specific_card" p={1} mb={1}>
                <Typography variant="h5" style={{ display: "flex" }}>
                  <span style={{ marginRight: "8px" }}>You sent</span>
                  <Grid
                    sx={{
                      color: (theme) => theme?.palette?.primary?.main,
                    }}
                    mr={1}
                  >
                    {exchangeInfo?.amount_from}{" "}
                    {exchangeInfo?.symbol_from.toUpperCase()} {""}
                    {exchangeInfo?.network_from && (
                      <span
                        className="net_wrapper"
                        style={{ position: "relative", top: "-3px" }}
                      >
                        {exchangeInfo?.network_from.toUpperCase()}
                      </span>
                    )}
                  </Grid>
                  to:
                </Typography>
                <Typography className="text_item long_text">
                  {exchangeInfo?.address_from}
                  <CopyToClipboard
                    text={exchangeInfo?.address_from}
                    onCopy={handleCopy}
                  >
                    <img
                      src="./assets/images/swapDetails/copy.svg"
                      alt="flashift"
                      style={{
                        marginLeft: "5px",
                        position: "relative",
                        top: "4px",
                        cursor: "pointer",
                      }}
                    />
                  </CopyToClipboard>
                </Typography>
              </Grid>
              {exchangeInfo?.extera_from && (
                <Grid className="specific_card" p={1} mb={1}>
                  <Typography variant="h5">Extra ID:</Typography>
                  <Typography className="text_item long_text">
                    {exchangeInfo?.extera_from}
                    <CopyToClipboard
                      text={exchangeInfo?.extera_from}
                      onCopy={handleCopy}
                    >
                      <img
                        src="./assets/images/swapDetails/copy.svg"
                        alt="flashift"
                        style={{
                          marginLeft: "5px",
                          position: "relative",
                          top: "4px",
                          cursor: "pointer",
                        }}
                      />
                    </CopyToClipboard>
                  </Typography>
                </Grid>
              )}
              {exchangeInfo?.hash_from && (
                <Grid className="specific_card" p={1} mb={1}>
                  <Typography variant="h5">Hash:</Typography>
                  <Typography className="text_item long_text">
                    <Link
                      target="_blank"
                      to={`${
                        net.filter(
                          (item) =>
                            item?.name.toUpperCase() ===
                            exchangeInfo?.network_from.toUpperCase()
                        )?.[0]?.explorer
                      }${exchangeInfo?.hash_from}`}
                    >
                      {exchangeInfo?.hash_from}
                    </Link>
                    <CopyToClipboard
                      text={exchangeInfo?.hash_from}
                      onCopy={handleCopy}
                    >
                      <img
                        src="./assets/images/swapDetails/copy.svg"
                        alt="flashift"
                        style={{
                          marginLeft: "5px",
                          position: "relative",
                          top: "4px",
                          cursor: "pointer",
                        }}
                      />
                    </CopyToClipboard>
                  </Typography>
                </Grid>
              )}

              <Grid className="specific_card" p={1} mb={1}>
                <Typography variant="h5">
                  <span style={{ marginRight: "8px" }}>Recipient</span>
                  <Grid
                    sx={{
                      color: (theme) => theme?.palette?.primary?.main,
                    }}
                    mr={1}
                  >
                    {exchangeInfo?.amount_to}{" "}
                    {exchangeInfo?.symbol_to.toUpperCase()} {""}
                    {exchangeInfo?.network_to && (
                      <span
                        className="net_wrapper"
                        style={{ position: "relative", top: "-3px" }}
                      >
                        {exchangeInfo?.network_to.toUpperCase()}
                      </span>
                    )}
                  </Grid>
                  address:
                </Typography>
                <Typography className="text_item long_text">
                  {exchangeInfo?.address_to}
                  <CopyToClipboard
                    text={exchangeInfo?.address_to}
                    onCopy={handleCopy}
                  >
                    <img
                      src="./assets/images/swapDetails/copy.svg"
                      alt="flashift"
                      style={{
                        marginLeft: "5px",
                        position: "relative",
                        top: "4px",
                        cursor: "pointer",
                      }}
                    />
                  </CopyToClipboard>
                </Typography>
              </Grid>
              {exchangeInfo?.extera_to && (
                <Grid className="specific_card" p={1} mb={1}>
                  <Typography variant="h5">Extra ID:</Typography>
                  <Typography className="text_item long_text">
                    {exchangeInfo?.extera_to}
                    <CopyToClipboard
                      text={exchangeInfo?.extera_to}
                      onCopy={handleCopy}
                    >
                      <img
                        src="./assets/images/swapDetails/copy.svg"
                        alt="flashift"
                        style={{
                          marginLeft: "5px",
                          position: "relative",
                          top: "4px",
                          cursor: "pointer",
                        }}
                      />
                    </CopyToClipboard>
                  </Typography>
                </Grid>
              )}
              {exchangeInfo?.hash_to && (
                <Grid className="specific_card" p={1}>
                  <Typography variant="h5">Hash:</Typography>
                  <Typography className="text_item long_text">
                    <Link
                      target="_blank"
                      to={`${
                        net.filter(
                          (item) =>
                            item?.name.toUpperCase() ===
                            exchangeInfo?.network_to.toUpperCase()
                        )?.[0]?.explorer
                      }${exchangeInfo?.hash_to}`}
                    >
                      {exchangeInfo?.hash_to}
                    </Link>

                    <CopyToClipboard
                      text={exchangeInfo?.hash_to}
                      onCopy={handleCopy}
                    >
                      <img
                        src="./assets/images/swapDetails/copy.svg"
                        alt="flashift"
                        style={{
                          marginLeft: "5px",
                          position: "relative",
                          top: "4px",
                          cursor: "pointer",
                        }}
                      />
                    </CopyToClipboard>
                  </Typography>
                </Grid>
              )}
            </AccordionDetails>
          </Accordion>
          {/* finished */}
          <Accordion
            expanded={expanded === "finished"}
            disabled={!nextStep.includes("finished")}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel3-content"
              id="panel3-header"
            >
              {nextStep.includes("finished") ? (
                <IconButton className="ok" style={{ marginRight: "5px" }}>
                  <CheckCircleOutlineIcon />
                </IconButton>
              ) : (
                <IconButton className="ok" style={{ marginRight: "5px" }}>
                  <RemoveCircleOutlineIcon style={{ color: "#cacaca" }} />
                </IconButton>
              )}
              Finished
            </AccordionSummary>
            <AccordionDetails>
              <Grid>
                <Typography mb={2} style={{ color: "#FF9800" }} variant="h6">
                  Congrats, Transaction Successful
                </Typography>
              </Grid>
              <Grid className="specific_card" p={1} mb={1}>
                <Typography variant="h5" style={{ display: "flex" }}>
                  <span style={{ marginRight: "8px" }}>You sent</span>
                  <Grid
                    sx={{
                      color: (theme) => theme?.palette?.primary?.main,
                    }}
                    mr={1}
                  >
                    {exchangeInfo?.amount_from}{" "}
                    {exchangeInfo?.symbol_from.toUpperCase()} {""}
                    {exchangeInfo?.network_from && (
                      <span
                        className="net_wrapper"
                        style={{ position: "relative", top: "-3px" }}
                      >
                        {exchangeInfo?.network_from.toUpperCase()}
                      </span>
                    )}
                  </Grid>
                  to:
                </Typography>
                <Typography className="text_item long_text">
                  {exchangeInfo?.address_from}
                  <CopyToClipboard
                    text={exchangeInfo?.address_from}
                    onCopy={handleCopy}
                  >
                    <img
                      src="./assets/images/swapDetails/copy.svg"
                      alt="flashift"
                      style={{
                        marginLeft: "5px",
                        position: "relative",
                        top: "4px",
                        cursor: "pointer",
                      }}
                    />
                  </CopyToClipboard>
                </Typography>
              </Grid>
              {exchangeInfo?.extera_from && (
                <Grid className="specific_card" p={1} mb={1}>
                  <Typography variant="h5">Extra ID:</Typography>
                  <Typography className="text_item long_text">
                    {exchangeInfo?.extera_from}
                    <CopyToClipboard
                      text={exchangeInfo?.extera_from}
                      onCopy={handleCopy}
                    >
                      <img
                        src="./assets/images/swapDetails/copy.svg"
                        alt="flashift"
                        style={{
                          marginLeft: "5px",
                          position: "relative",
                          top: "4px",
                          cursor: "pointer",
                        }}
                      />
                    </CopyToClipboard>
                  </Typography>
                </Grid>
              )}
              {exchangeInfo?.hash_from && (
                <Grid className="specific_card" p={1} mb={1}>
                  <Typography variant="h5">Hash:</Typography>
                  <Typography className="text_item long_text">
                    <Link
                      target="_blank"
                      to={`${
                        net.filter(
                          (item) =>
                            item?.name.toUpperCase() ===
                            exchangeInfo?.network_from.toUpperCase()
                        )?.[0]?.explorer
                      }${exchangeInfo?.hash_from}`}
                    >
                      {exchangeInfo?.hash_from}
                    </Link>
                    <CopyToClipboard
                      text={exchangeInfo?.hash_from}
                      onCopy={handleCopy}
                    >
                      <img
                        src="./assets/images/swapDetails/copy.svg"
                        alt="flashift"
                        style={{
                          marginLeft: "5px",
                          position: "relative",
                          top: "4px",
                          cursor: "pointer",
                        }}
                      />
                    </CopyToClipboard>
                  </Typography>
                </Grid>
              )}
              <Grid className="specific_card" p={1} mb={1}>
                <Typography variant="h5">
                  <span style={{ marginRight: "8px" }}>Recipient</span>
                  <Grid
                    sx={{
                      color: (theme) => theme?.palette?.primary?.main,
                    }}
                    mr={1}
                  >
                    {exchangeInfo?.amount_to}{" "}
                    {exchangeInfo?.symbol_to.toUpperCase()} {""}
                    {exchangeInfo?.network_to && (
                      <span
                        className="net_wrapper"
                        style={{ position: "relative", top: "-3px" }}
                      >
                        {exchangeInfo?.network_to.toUpperCase()}
                      </span>
                    )}
                  </Grid>
                  address:
                </Typography>
                <Typography className="text_item long_text">
                  {exchangeInfo?.address_to}
                  <CopyToClipboard
                    text={exchangeInfo?.address_to}
                    onCopy={handleCopy}
                  >
                    <img
                      src="./assets/images/swapDetails/copy.svg"
                      alt="flashift"
                      style={{
                        marginLeft: "5px",
                        position: "relative",
                        top: "4px",
                        cursor: "pointer",
                      }}
                    />
                  </CopyToClipboard>
                </Typography>
              </Grid>
              {exchangeInfo?.extera_to && (
                <Grid className="specific_card" p={1} mb={1}>
                  <Typography variant="h5">Extra ID:</Typography>
                  <Typography className="text_item long_text">
                    {exchangeInfo?.extera_to}
                    <CopyToClipboard
                      text={exchangeInfo?.extera_to}
                      onCopy={handleCopy}
                    >
                      <img
                        src="./assets/images/swapDetails/copy.svg"
                        alt="flashift"
                        style={{
                          marginLeft: "5px",
                          position: "relative",
                          top: "4px",
                          cursor: "pointer",
                        }}
                      />
                    </CopyToClipboard>
                  </Typography>
                </Grid>
              )}
              {exchangeInfo?.hash_to && (
                <Grid className="specific_card" p={1}>
                  <Typography variant="h5">Hash:</Typography>
                  <Typography className="text_item long_text">
                    <Link
                      target="_blank"
                      to={`${
                        net.filter(
                          (item) =>
                            item?.name.toUpperCase() ===
                            exchangeInfo?.network_to.toUpperCase()
                        )?.[0]?.explorer
                      }${exchangeInfo?.hash_to}`}
                    >
                      {exchangeInfo?.hash_to}
                    </Link>

                    <CopyToClipboard
                      text={exchangeInfo?.hash_to}
                      onCopy={handleCopy}
                    >
                      <img
                        src="./assets/images/swapDetails/copy.svg"
                        alt="flashift"
                        style={{
                          marginLeft: "5px",
                          position: "relative",
                          top: "4px",
                          cursor: "pointer",
                        }}
                      />
                    </CopyToClipboard>
                  </Typography>
                </Grid>
              )}
              <Grid my={4}>
                <Typography>rate us on Trustpilot</Typography>
                <Typography>
                  <a
                    className="starBox"
                    href="https://www.trustpilot.com/evaluate/flashift.app"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span id="starOne">
                      <svg
                        viewBox="0 0 16 16"
                        fill="#f39c12"
                        className="icon_icon__ECGRl"
                        xmlns="http://www.w3.org/2000/svg"
                        width="22px"
                        height="22px"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M9.88 6.225H16l-4.929 3.504-3.047 2.149-4.953 3.504L4.952 9.73 0 6.225h6.119L8 .572l1.881 5.653Zm1.596 4.812L8 11.9l4.929 3.527-1.453-4.392Z"
                        ></path>
                      </svg>
                    </span>
                    <span id="starTwo">
                      <svg
                        viewBox="0 0 16 16"
                        fill="#f39c12"
                        className="icon_icon__ECGRl"
                        xmlns="http://www.w3.org/2000/svg"
                        width="22px"
                        height="22px"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M9.88 6.225H16l-4.929 3.504-3.047 2.149-4.953 3.504L4.952 9.73 0 6.225h6.119L8 .572l1.881 5.653Zm1.596 4.812L8 11.9l4.929 3.527-1.453-4.392Z"
                        ></path>
                      </svg>
                    </span>
                    <span id="starThree">
                      <svg
                        viewBox="0 0 16 16"
                        fill="#f39c12"
                        className="icon_icon__ECGRl"
                        xmlns="http://www.w3.org/2000/svg"
                        width="22px"
                        height="22px"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M9.88 6.225H16l-4.929 3.504-3.047 2.149-4.953 3.504L4.952 9.73 0 6.225h6.119L8 .572l1.881 5.653Zm1.596 4.812L8 11.9l4.929 3.527-1.453-4.392Z"
                        ></path>
                      </svg>
                    </span>
                    <span id="starFour">
                      <svg
                        viewBox="0 0 16 16"
                        fill="#f39c12"
                        className="icon_icon__ECGRl"
                        xmlns="http://www.w3.org/2000/svg"
                        width="22px"
                        height="22px"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M9.88 6.225H16l-4.929 3.504-3.047 2.149-4.953 3.504L4.952 9.73 0 6.225h6.119L8 .572l1.881 5.653Zm1.596 4.812L8 11.9l4.929 3.527-1.453-4.392Z"
                        ></path>
                      </svg>
                    </span>
                    <span id="starFive">
                      <svg
                        viewBox="0 0 16 16"
                        fill="#f39c12"
                        className="icon_icon__ECGRl"
                        xmlns="http://www.w3.org/2000/svg"
                        width="22px"
                        height="22px"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M9.88 6.225H16l-4.929 3.504-3.047 2.149-4.953 3.504L4.952 9.73 0 6.225h6.119L8 .572l1.881 5.653Zm1.596 4.812L8 11.9l4.929 3.527-1.453-4.392Z"
                        ></path>
                      </svg>
                    </span>
                  </a>
                </Typography>
              </Grid>
              <Grid>
                <Button variant="contained" fullWidth onClick={handleRedo}>
                  Redo This Exchange
                </Button>
              </Grid>
            </AccordionDetails>
          </Accordion>
        </Grid>
      </CustomCard>
    </Grid>
  );
};

export default SwapDetails;
